import type { Item } from '@/domain/Item';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
  page: number | null;
}

export interface ItemsAdminResponse {
  data: Array<Item>;
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: {
    current_page: number;
    from: number;
    last_page: number;
    links: Array<PaginationLink>;
    path: string;
    per_page: number;
    to: number;
    total: number;
  };
}

export interface ItemAdminResponse {
  data: Item;
}

export const getAdminItemsQuery = (page?: number) =>
  queryOptions({
    queryKey: queryKeys.adminItems.all(page),
    queryFn: async () => {
      return await api
        .get('admin/items', {
          searchParams: {
            per_page: 500,
            ...(page ? { page } : {}),
          },
        })
        .json<ItemsAdminResponse>();
    },
  });

export const getAdminItemQuery = (itemId: number) =>
  queryOptions({
    queryKey: queryKeys.adminItems.single(itemId),
    queryFn: async () => {
      const response = await api
        .get(`admin/items/${itemId}`)
        .json<ItemAdminResponse>();
      return response.data;
    },
  });
